let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a36zY")).then(() => parcelRequire('i1aQI'));